<ph-dialog open [heading]="dialogTitle" (ph-close)="cancel()">
    <ph-columns min="360px">
        <app-mark-as-paid-form
            [localPayable]="data.payable"
            [potentialTransactionMatches]="potentialTransactionMatches">
        </app-mark-as-paid-form>

        <app-payable-review
            [payable]="data.payable"
            [displayPaymentDetails]="false"
        ></app-payable-review>
    </ph-columns>

    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="filled" (click)="cancel()">Back</ph-button>
        <ph-button [disabled]="isSubmitting" (click)="markAsPaid()">{{buttonText}}</ph-button>
    </ph-actions>
</ph-dialog>
